<div class="modal-header">
    <h4 class="modal-title" id="mondalAddCampaignTitle">Campos extra de sucursales</h4>
    <button type="button" class="btn-close" mat-dialog-close></button>
</div>
<mat-dialog-content>
    <div class="modal-body">
        <h6>
            <span *ngIf="promotionFiles" > <mat-icon class="align-middle">update</mat-icon> Última actualización: <strong>{{ promotionFiles[0].created_at | date : "dd/MM/yyyy hh:mma": "-0000" }} {{ " - " + promotionFiles[0].user }}</strong></span>
        </h6>
        <h6 class="pb-4">
            <span class="align-middle">Lista de Archivos de campos extra</span>
            <div class="float-end align-middle">
                <a *ngIf="promotionFiles" href="{{promotionFiles[0]?.url}}" target="_blank" mat-stroked-button color="primary">Descarga último archivo <mat-icon class="align-middle ms-1">file_download</mat-icon></a>
                <button mat-flat-button color="primary" class="ms-4"  (click)="openDialogUploadDistFile()">Subir archivo
                    <mat-icon>upload_file</mat-icon>
                </button>
            </div>
        </h6>        
        <mat-divider></mat-divider>
        <div>
            <div class="row g-2">
                <div class="col mb-0">
                    <div class="table-responsive text-nowrap">
                        <table class="table table-hover">
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Archivo</th>
                                    <th>Responsable</th>
                                    <th>Fecha de Registro</th>
                                    <th>Equipo</th>
                                </tr>
                            </thead>
                            <tbody class="table-border-bottom-0">
                                <tr *ngFor="let file of promotionFiles">
                                    <td>
                                        {{ file.id }}
                                    </td>
                                    <td>
                                        <a href="{{ file.url }}" target="_blank">
                                            {{ file.name }}
                                        </a>
                                    </td>
                                    <td>
                                        {{ file.user }}
                                    </td>
                                    <td>
                                        {{ file.created_at | date : "dd/MM/yyyy hh:mma": "-0000" }}
                                    </td>
                                    <td>
                                        <span class="badge {{file.id_rol==3?'bg-info':'bg-warning'}}">{{file.rol}}</span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</mat-dialog-content>